import React from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const TakeOverReviewModal = (props) => {
  const navigate = useNavigate();
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="delete-modal"
    >
      <Modal.Body>
        <div className="text-center">
          <h4>{`Currently ${props?.detail?.machinename} is reviewing by ${
            props?.detail?.reviewername ? props?.detail?.reviewername : ""
          }`}</h4>
          <p>{`Are you sure you want to take over ${props?.detail?.machinename}?`}</p>
          <div className="d-flex align-items-center gap-2 mt-3">
            <button className="grey-btn" type="reset" onClick={props.onHide}>
              Close
            </button>
            <button
              className="blue-btn"
              onClick={(e) => {
                navigate(
                  `/machine-review/${props?.detail?.machineid}/${props?.detail?.versionnumber}`
                );
              }}
            >
              Yes
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TakeOverReviewModal;
